import { Component, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "ds-toggle",
  templateUrl: "./ds-toggle.component.html",
  styleUrls: ["./ds-toggle.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DsToggleComponent),
      multi: true,
    },
  ],
})
export class DsToggleComponent implements ControlValueAccessor {
  @Input() label: string = "";
  @Input() disabled: boolean = false;
  @Input() value: string = "";
  @Input() name: string = "";

  private _checked: boolean = false;
  private onChange = (value: boolean) => {};
  private onTouched = () => {};

  constructor() {}

  get checked(): boolean {
    return this._checked;
  }

  @Input() set checked(value: boolean) {
    this._checked = value;
    this.onChange(value);
  }

  writeValue(value: boolean): void {
    this._checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onToggleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.onTouched();
  }
}
